import { useStore } from "../../hooks/store";
import Styles from "./Form.module.css";
import CustomField from "../shared/CustomTextField";
import { Formik } from "formik";
import { Button, ListSubheader, MenuItem } from "@mui/material";
// import { postSchool } from "../../../utils/API/schoolMethods";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import moment from "moment-timezone";
import { drivingLesson, drivingLessonStatus } from "../../utils/config";
import {
  deleteLesson,
  postLesson,
  updateLesson,
} from "../../utils/API/schoolMethods";
import { useState } from "react";
import { drivingLessonValidation } from "../../utils/validation";
import { getDrivingTime } from "../../utils/API/userMethods";
export default function DrivingLessonForm() {
  const store = useStore();
  const lessonData = store.form.dataToUpdate;
  const {
    studentList,
    teacherList,
    schoolList,
    currentStudent,
    currentTeacher,
    categoryList,
    groupList,
  } = lessonData;
  const initValues = lessonData;
  const [dates, setDates] = useState({
    start: moment(initValues.lesson_start_time),
    end: moment(initValues.lesson_end_time),
  });
  const [avalibleStudents, setAvalibleStudents] = useState(studentList || []);
  const [avalibleCategory, setAvalibleCategory] = useState(categoryList || []);

  const submitLesson = (values) => {
    postLesson({
      ...values,
      lesson_start_time: moment(values.lesson_start_time).toISOString(),
      lesson_end_time: moment(values.lesson_end_time).toISOString(),
      lesson_status: 0,
    }).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }
      store.setAlert(data, "error");
    });
  };

  const handleDelete = async () => {
    const confirm = await window.confirm(
      "Вы уверены что хотите удалить запись о практическом занятии? Это действие невозможно отменить",
    );
    confirm &&
      deleteLesson(initValues.id).then(({ data, status }) => {
        if (status === 200) {
          store.closeForm();
          store.setAlert(data, "success");
          store.form.callBack();
          return;
        }
        store.setAlert(data, "error");
      });
  };

  const handleUpdate = (values) => {
    updateLesson(values.id, {
      ...values,
      lesson_start_time: moment(values.lesson_start_time).toISOString(),
      lesson_end_time: moment(values.lesson_end_time).toISOString(),
    }).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }
      store.setAlert(data, "error");
    });
  };

  const wrapperStyle = {} && { flexDirection: "row" };
  console.log(initValues);
  return (
    <Formik
      validationSchema={drivingLessonValidation}
      initialValues={{
        id: initValues.id,
        school_id: initValues.school_id || "",
        student_id: initValues.student_id || "",
        teacher_id: initValues.teacher_id || "",
        lesson_type: initValues.lesson_type || "",
        lesson_status: (initValues.id && initValues.lesson_status) || 0,
        lesson_start_time: initValues.lesson_start_time || moment(),
        lesson_end_time: initValues.lesson_end_time || moment().add(1, "h"),
        description: initValues.description || "",
        category_id: Number(initValues.category_id) || null,
      }}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={(values, { setSubmitting, setErrors }) => {
        setSubmitting(true);
        initValues.id ? handleUpdate(values) : submitLesson(values);
        // submitSchool(values);
        setSubmitting(false);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        handleReset,
        submitForm,
        /* and other goodies */
      }) => (
        <>
          <p>
            {initValues.id
              ? "Изменение урока практического вождения"
              : "Добавление урока практического вождения"}
          </p>
          <form onSubmit={handleSubmit}>
            <div className={Styles.form_content} style={wrapperStyle}>
              <div className={Styles.form_fields}>
                {console.log(values)}
                <CustomField
                  error={errors.school_id}
                  helperText={errors.school_id}
                  select
                  name="school_id"
                  label={"Автошкола"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled
                  value={values.school_id}>
                  {schoolList.map((school) => (
                    <MenuItem value={Number(school.id)}>{school.name}</MenuItem>
                  ))}
                </CustomField>
                <CustomField
                  error={errors.teacher_id}
                  helperText={errors.teacher_id}
                  disabled={currentTeacher}
                  select
                  name="teacher_id"
                  label={"Преп. вождения"}
                  onChange={(e) => {
                    handleChange(e);

                    const teacherStudens = [];

                    groupList.forEach((group) => {
                      if (
                        group.grouped_users.find(
                          (u) => Number(u.id) === Number(e.target.value),
                        )
                      ) {
                        group.grouped_users.forEach((stud) => {
                          stud.role === 1 &&
                            !stud.is_delete &&
                            !stud.is_block &&
                            teacherStudens.push(stud);
                        });
                      }
                    });
                    setAvalibleStudents(teacherStudens);
                  }}
                  onBlur={handleBlur}
                  value={values.teacher_id}>
                  {teacherList.map((teacher) => (
                    <MenuItem value={Number(teacher.id)}>
                      {teacher.name}
                    </MenuItem>
                  ))}
                </CustomField>
                <CustomField
                  disabled={currentStudent || !values.teacher_id}
                  select
                  error={errors.student_id}
                  helperText={errors.student_id}
                  name="student_id"
                  label={"Ученик"}
                  onChange={(e) => {
                    handleChange(e);
                    getDrivingTime(e.target.value).then(({ data, status }) => {
                      if (status === 200) {
                        if (data.length === 0) {
                          setAvalibleCategory([
                            { id: "", name: "Нет доступных категорий" },
                          ]);
                        } else
                          setAvalibleCategory(
                            data.map((timeRec) => {
                              return {
                                id: timeRec.category_id,
                                name: timeRec.name,
                              };
                            }),
                          );
                      } else {
                        setAvalibleCategory([
                          { id: "", name: "Ошибка получения категорий" },
                        ]);
                      }
                    });
                  }}
                  onBlur={handleBlur}
                  value={values.student_id}>
                  {avalibleStudents.map((s) => (
                    <MenuItem value={Number(s.id)}>{s.name}</MenuItem>
                  ))}
                </CustomField>
                <CustomField
                  disabled={!values.student_id}
                  select
                  error={errors.category_id}
                  helperText={errors.category_id}
                  name="category_id"
                  label={"Категория ТС исп. на заняти"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.category_id}>
                  {avalibleCategory.map((s) => (
                    <MenuItem value={Number(s.id)}>{s.name}</MenuItem>
                  ))}
                </CustomField>
                <CustomField
                  select
                  name="lesson_type"
                  error={errors.lesson_type}
                  helperText={errors.lesson_type}
                  label={"Тип урока"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  defaultValue={values.lesson_type}
                  value={Number(values.lesson_type)}>
                  {drivingLesson.map((lessonType) => (
                    <MenuItem value={Number(lessonType.id)}>
                      {lessonType.title}
                    </MenuItem>
                  ))}
                </CustomField>
                <CustomField
                  disabled={!values.id}
                  select
                  name="lesson_status"
                  error={errors.lesson_status}
                  helperText={errors.lesson_status}
                  label={"Состояние урока"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.lesson_status}>
                  {drivingLessonStatus.map((lessonType) => (
                    <MenuItem value={lessonType.id}>
                      {lessonType.title}
                    </MenuItem>
                  ))}
                </CustomField>
                <DateTimePicker
                  error={errors.lesson_start_time}
                  helperText={errors.lesson_start_time}
                  name="lesson_start_time"
                  slotProps={{ textField: { size: "small" } }}
                  label="Дата/время начала занятия"
                  format="MM/DD/YYYY HH:mm"
                  onChange={(e) => {
                    setDates({ ...dates, start: e });
                    setFieldValue("lesson_start_time", e);
                  }}
                  value={dates.start}
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock,
                  }}
                />
                <DateTimePicker
                  error={errors.lesson_end_time}
                  helperText={errors.lesson_end_time}
                  name="lesson_end_time"
                  label="Дата/время окончания занятия"
                  slotProps={{ textField: { size: "small" } }}
                  format="MM/DD/YYYY HH:mm"
                  onChange={(e) => {
                    setDates({ ...dates, end: e });
                    setFieldValue("lesson_end_time", e);
                  }}
                  value={dates.end}
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock,
                  }}
                />

                <CustomField
                  rows={3}
                  multiline
                  name="description"
                  label={"Заметка к занятию"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                />
              </div>
            </div>

            <div
              className="form_actions"
              style={{
                justifyContent: "space-between",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}>
              <Button
                variant="contained"
                color="error"
                disabled={!initValues.id}
                onClick={handleDelete}>
                Удалить
              </Button>
              <Button variant="contained" onClick={handleSubmit}>
                Сохранить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
